import { createSelector } from 'reselect';
const getModalsData = state => state.modals;
export const getModalType = createSelector(getModalsData, modalsData => modalsData.modalType);
export const getModalProps = createSelector(getModalsData, modalsData => modalsData.modalProps);
export const getIsModalOpenWithProps = createSelector([getModalsData, (_, modalType) => modalType], (modalsData, inputModalType) => {
  const isOpen = modalsData.modalType === inputModalType;
  const props = isOpen ? modalsData.modalProps : {};
  return {
    isOpen,
    props
  };
});